import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const BlogPage = lazy(() => import('../pages/blog/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const ReferencesPage = lazy(() => import('../pages/references/page'));

// Solutions
const AIAgentPage = lazy(() => import('../pages/solutions/ai-agent/page'));
const ImageProcessingPage = lazy(() => import('../pages/solutions/image-processing/page'));
const DecisionSupportPage = lazy(() => import('../pages/solutions/decision-support/page'));

// Sectors
const RetailSectorPage = lazy(() => import('../pages/sectors/retail/page'));
const FinanceSectorPage = lazy(() => import('../pages/sectors/finance/page'));
const AutomotiveSectorPage = lazy(() => import('../pages/sectors/automotive/page'));
const HealthSectorPage = lazy(() => import('../pages/sectors/health/page'));
const EnergySectorPage = lazy(() => import('../pages/sectors/energy/page'));
const ServiceSectorPage = lazy(() => import('../pages/sectors/service/page'));
const PublicSectorPage = lazy(() => import('../pages/sectors/public/page'));
const ManufacturingSectorPage = lazy(() => import('../pages/sectors/manufacturing/page'));
const AllSectorsPage = lazy(() => import('../pages/sectors/all-sectors/page'));

const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/hakkimizda',
    element: <AboutPage />,
  },
  {
    path: '/blog',
    element: <BlogPage />,
  },
  {
    path: '/iletisim',
    element: <ContactPage />,
  },
  {
    path: '/referanslar',
    element: <ReferencesPage />,
  },
  // Solutions
  {
    path: '/cozumlerimiz/yapay-zeka-agent',
    element: <AIAgentPage />,
  },
  {
    path: '/cozumlerimiz/goruntu-isleme',
    element: <ImageProcessingPage />,
  },
  {
    path: '/cozumlerimiz/karar-destek',
    element: <DecisionSupportPage />,
  },
  // Sectors
  {
    path: '/sektorler',
    element: <AllSectorsPage />,
  },
  {
    path: '/sektorler/perakende-sektoru',
    element: <RetailSectorPage />,
  },
  {
    path: '/sektorler/finans',
    element: <FinanceSectorPage />,
  },
  {
    path: '/sektorler/otomotiv-sektoru',
    element: <AutomotiveSectorPage />,
  },
  {
    path: '/sektorler/saglik-sektoru',
    element: <HealthSectorPage />,
  },
  {
    path: '/sektorler/enerji',
    element: <EnergySectorPage />,
  },
  {
    path: '/sektorler/hizmet-sektoru',
    element: <ServiceSectorPage />,
  },
  {
    path: '/sektorler/kamu',
    element: <PublicSectorPage />,
  },
  {
    path: '/sektorler/imalat',
    element: <ManufacturingSectorPage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;
